import searchIcon from "assets/svg/searchIcon.svg";

export const SearchInput = ({
  handleInputChange,
  fullWidth,
  transparentType,
  longer,
}: {
  handleInputChange: (val: string) => void;
  fullWidth?: boolean;
  transparentType?: boolean;
  longer?: boolean;
}) => {
  return (
    <div className="relative">
      <img
        className={`absolute ${longer ? "top-3" : "top-2"}  left-4`}
        src={searchIcon}
        alt={""}
      />
      <input
        type={"text"}
        onChange={(e) => handleInputChange(e.target.value)}
        className={` ${
          transparentType ? "border border-[#F5F5F5]" : "bg-[#F5F5F5]"
        } px-4 pl-10 focus:outline-none focus:border-2 text-sm font-grotesk font-semibold ${
          longer ? "py-3" : "py-2"
        } rounded-lg ${fullWidth && "w-full"}`}
        placeholder="Search"
      />
    </div>
  );
};
